import useRequirements from '../../../hooks/use-requirements'
import React from 'react'
import { find, first, get, uniqBy, findIndex, set } from 'lodash'

const useEditRequirements = ({
    courseRequirements = [],
    onCourseRequirementsChange = () => {},
}) => {
    const [ requirementLookups ] = useRequirements()

    const requirements = requirementLookups.map( r => {
        const courseRequirement = find(courseRequirements, { id: r.id })
        return {
            id: r.id,
            name: r.name,
            enabled: Boolean(courseRequirement),
            value: first(get(courseRequirement, 'requirementValues', []))
        }
    })

    const addRequirement = React.useCallback(id => {
        const requirements = [...courseRequirements, { id, requirementValues: [] }]
        onCourseRequirementsChange(uniqBy(requirements, 'id'))
    }, [courseRequirements, onCourseRequirementsChange])

    const removeRequirement = React.useCallback(id => {
        const requirements = courseRequirements.filter(r => r.id !== id)
        onCourseRequirementsChange(requirements)
    }, [courseRequirements, onCourseRequirementsChange])

    const setRequirementValue = React.useCallback((id, value) => {
        const index = findIndex(courseRequirements, { id })
        if (index >= 0) {
            set(courseRequirements[index], 'requirementValues', [ value ])
            onCourseRequirementsChange(courseRequirements)
        }
    }, [courseRequirements, onCourseRequirementsChange])

    return {
        requirements,
        addRequirement,
        removeRequirement,
        setRequirementValue,
    }
}

export default useEditRequirements